import { render, staticRenderFns } from "./InformacoesIA.vue?vue&type=template&id=292c0a23&scoped=true&"
import script from "./InformacoesIA.vue?vue&type=script&lang=js&"
export * from "./InformacoesIA.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesIA.vue?vue&type=style&index=0&id=292c0a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292c0a23",
  null
  
)

export default component.exports